"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("@trs/utils");
var _CardTitle = _interopRequireDefault(require("./CardTitle"));
var _CustomMenuList = _interopRequireDefault(require("../misc/CustomMenuList"));
var _tooltip = require("../tooltip");
var _ActionCard = _interopRequireDefault(require("./ActionCard.style"));
var _excluded = ["title", "subtitle", "titleProps", "delimiterProps", "customTitle", "renderMedia", "contextualMenu", "children", "className", "isTile", "connectWithTooltip", "tooltipProps"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var ActionCard = function ActionCard(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    titleProps = _ref.titleProps,
    delimiterProps = _ref.delimiterProps,
    customTitle = _ref.customTitle,
    renderMedia = _ref.renderMedia,
    contextualMenu = _ref.contextualMenu,
    children = _ref.children,
    className = _ref.className,
    isTile = _ref.isTile,
    connectWithTooltip = _ref.connectWithTooltip,
    tooltipProps = _ref.tooltipProps,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var actionCardTooltipProps = {
    dataTip: title || tooltipProps.dataTip,
    dataFor: "action-card-title-".concat(titleProps.id) || tooltipProps.dataFor,
    dataPlace: 'top' || tooltipProps.dataPlace,
    dataOffset: '' || tooltipProps.dataOffset
  };
  return /*#__PURE__*/_react["default"].createElement(_ActionCard["default"], {
    className: "action-card-wrapper ".concat(className),
    isTile: isTile
  }, renderMedia, /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "action-card-container"
  }, otherProps), /*#__PURE__*/_react["default"].createElement("div", {
    className: "action-card-header"
  }, contextualMenu && /*#__PURE__*/_react["default"].createElement(_CustomMenuList["default"], {
    menuConfig: contextualMenu,
    className: "contextual-menu"
  }), title && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, connectWithTooltip && /*#__PURE__*/_react["default"].createElement(_tooltip.Tooltip, {
    id: actionCardTooltipProps.dataFor
  }), /*#__PURE__*/_react["default"].createElement(_CardTitle["default"], _extends({
    className: "action-card-title",
    title: title,
    titleProps: titleProps,
    delimiterProps: delimiterProps,
    withSubtitle: !(0, _utils.isBlank)(subtitle)
  }, connectWithTooltip && {
    tooltipProps: _objectSpread({}, {
      'data-tip': actionCardTooltipProps.dataTip,
      'data-for': actionCardTooltipProps.dataFor,
      'data-place': actionCardTooltipProps.dataPlace,
      'data-offset': actionCardTooltipProps.dataOffset
    } || tooltipProps)
  }))), customTitle && /*#__PURE__*/_react["default"].createElement("div", {
    className: "action-card-custom-title"
  }, customTitle)), subtitle && /*#__PURE__*/_react["default"].createElement("div", {
    className: "action-card-subtitle"
  }, subtitle), children));
};
ActionCard.defaultProps = {
  className: '',
  title: '',
  subtitle: '',
  isTile: false,
  connectWithTooltip: false,
  titleProps: {
    id: '',
    titleFontSize: '',
    isBold: true,
    isUppercase: false,
    textTransform: 'capitalize'
  },
  delimiterProps: {
    titleDelimiter: false,
    position: 'left',
    topMargin: '',
    type: 'small'
  },
  contextualMenu: '',
  customTitle: '',
  renderMedia: null,
  children: undefined,
  tooltipProps: {
    dataTip: '',
    dataFor: '',
    dataPlace: 'top',
    dataOffset: ''
  }
};
ActionCard.propTypes = {
  renderMedia: _propTypes["default"].node,
  className: _propTypes["default"].string,
  /** Text or html to be displayed inside the card */
  children: _propTypes["default"].node,
  /** A text to be displayed as the card title */
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  /** A text to be displayed as the card subtitle */
  subtitle: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  /** Attributes for the card title */
  titleProps: _propTypes["default"].shape({
    id: _propTypes["default"].string,
    titleFontSize: _propTypes["default"].string,
    isBold: _propTypes["default"].bool,
    isUppercase: _propTypes["default"].bool,
    textTransform: _propTypes["default"].oneOf(['none', 'capitalize', 'uppercase', 'lowercase'])
  }),
  /** Attributes for the delimiter */
  delimiterProps: _propTypes["default"].shape({
    titleDelimiter: _propTypes["default"].bool,
    position: _propTypes["default"].string,
    topMargin: _propTypes["default"].string,
    type: _propTypes["default"].oneOf(['small', 'medium'])
  }),
  contextualMenu: _propTypes["default"].oneOfType([_propTypes["default"].shape({}), _propTypes["default"].arrayOf(_propTypes["default"].shape({})), _propTypes["default"].node]),
  customTitle: _propTypes["default"].node,
  isTile: _propTypes["default"].bool,
  connectWithTooltip: _propTypes["default"].bool,
  tooltipProps: _propTypes["default"].shape({
    dataTip: _propTypes["default"].string,
    dataFor: _propTypes["default"].string,
    dataPlace: _propTypes["default"].string,
    dataOffset: _propTypes["default"].string
  })
};
ActionCard.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ActionCard",
  "props": {
    "className": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "title": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "A text to be displayed as the card title",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "node"
        }]
      },
      "required": false
    },
    "subtitle": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "A text to be displayed as the card subtitle",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "node"
        }]
      },
      "required": false
    },
    "isTile": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "connectWithTooltip": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "titleProps": {
      "defaultValue": {
        "value": "{\r\n  id: '',\r\n  titleFontSize: '',\r\n  isBold: true,\r\n  isUppercase: false,\r\n  textTransform: 'capitalize',\r\n}",
        "computed": false
      },
      "description": "Attributes for the card title",
      "type": {
        "name": "shape",
        "value": {
          "id": {
            "name": "string",
            "required": false
          },
          "titleFontSize": {
            "name": "string",
            "required": false
          },
          "isBold": {
            "name": "bool",
            "required": false
          },
          "isUppercase": {
            "name": "bool",
            "required": false
          },
          "textTransform": {
            "name": "enum",
            "value": [{
              "value": "'none'",
              "computed": false
            }, {
              "value": "'capitalize'",
              "computed": false
            }, {
              "value": "'uppercase'",
              "computed": false
            }, {
              "value": "'lowercase'",
              "computed": false
            }],
            "required": false
          }
        }
      },
      "required": false
    },
    "delimiterProps": {
      "defaultValue": {
        "value": "{\r\n  titleDelimiter: false,\r\n  position: 'left',\r\n  topMargin: '',\r\n  type: 'small',\r\n}",
        "computed": false
      },
      "description": "Attributes for the delimiter",
      "type": {
        "name": "shape",
        "value": {
          "titleDelimiter": {
            "name": "bool",
            "required": false
          },
          "position": {
            "name": "string",
            "required": false
          },
          "topMargin": {
            "name": "string",
            "required": false
          },
          "type": {
            "name": "enum",
            "value": [{
              "value": "'small'",
              "computed": false
            }, {
              "value": "'medium'",
              "computed": false
            }],
            "required": false
          }
        }
      },
      "required": false
    },
    "contextualMenu": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "shape",
          "value": {}
        }, {
          "name": "arrayOf",
          "value": {
            "name": "shape",
            "value": {}
          }
        }, {
          "name": "node"
        }]
      },
      "required": false
    },
    "customTitle": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "renderMedia": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "children": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Text or html to be displayed inside the card",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "tooltipProps": {
      "defaultValue": {
        "value": "{\r\n  dataTip: '',\r\n  dataFor: '',\r\n  dataPlace: 'top',\r\n  dataOffset: '',\r\n}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "dataTip": {
            "name": "string",
            "required": false
          },
          "dataFor": {
            "name": "string",
            "required": false
          },
          "dataPlace": {
            "name": "string",
            "required": false
          },
          "dataOffset": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false
    }
  }
};
var _default = ActionCard;
exports["default"] = _default;